(function () {
  'use strict';

  const MOBILE_MAX_WIDTH = 999;
  const VALID_LAYOUTS = [1, 2, 3];

  function isMobile() {
    return window.innerWidth <= MOBILE_MAX_WIDTH;
  }

  function getBuilder() {
    return document.querySelector('#product-builder');
  }

  function getThumbnailElements(builder) {
    const thumbs = builder?.querySelector('.cpb-swiper-thumbnails');
    const container = thumbs?.querySelector('.swiper-container');
    const wrapper = thumbs?.querySelector('.swiper-wrapper');

    return {
      thumbs,
      container,
      wrapper
    };
  }

  function getActiveSlide(wrapper) {
    if (!wrapper) return null;

    return (
      wrapper.querySelector('.swiper-slide-thumb-active') ||
      wrapper.querySelector('.swiper-slide-active') ||
      wrapper.querySelector('.swiper-slide-active-manual')
    );
  }

  function applyLayoutClass(builder) {
    let thumbnailLayout = Number(window.cpbThumbnailLayout) || 1;

    if (!VALID_LAYOUTS.includes(thumbnailLayout)) {
      thumbnailLayout = 1;
    }

    builder.classList.remove(
      'cpb-thumb-layout-1',
      'cpb-thumb-layout-2',
      'cpb-thumb-layout-3'
    );

    builder.classList.add(
      `cpb-thumb-layout-${thumbnailLayout}`
    );

    return thumbnailLayout;
  }

  function applyObjectFitClass(builder) {
    const objectFit = Number(window.cpbObjectFit) || 1;

    builder.classList.remove(
      'cpb-object-fit-contain',
      'cpb-object-fit-cover'
    );

    builder.classList.add(
      objectFit === 2
        ? 'cpb-object-fit-cover'
        : 'cpb-object-fit-contain'
    );
  }

  function initHorizontalCentredLayout(builder, layoutNumber) {
    const {
      thumbs,
      container,
      wrapper
    } = getThumbnailElements(builder);

    if (!thumbs || !container || !wrapper) {
      return false;
    }

    const datasetKey =
      layoutNumber === 1
        ? 'cpbLayout1Initialised'
        : 'cpbLayout3Initialised';

    if (wrapper.dataset[datasetKey] === 'true') {
      return true;
    }

    wrapper.dataset[datasetKey] = 'true';

    const cssVariable =
      layoutNumber === 1
        ? '--mobile-layout1-thumb-x'
        : '--mobile-layout3-thumb-x';

    const noFadeClass =
      layoutNumber === 1
        ? 'cpb-layout1-thumbs-no-fade'
        : 'cpb-layout3-thumbs-no-fade';

    const scrolledClass =
      layoutNumber === 1
        ? 'cpb-layout1-thumbs-scrolled'
        : 'cpb-layout3-thumbs-scrolled';

    const atEndClass =
      layoutNumber === 1
        ? 'cpb-layout1-thumbs-at-end'
        : 'cpb-layout3-thumbs-at-end';

    let rafId = null;

    function getSlides() {
      return Array.from(
        wrapper.querySelectorAll('.swiper-slide')
      );
    }

    function updateFades() {
      const slides = getSlides();
      const active = getActiveSlide(wrapper);

      if (!slides.length || !active) {
        return;
      }

      const activeIndex = slides.indexOf(active);
      const lastIndex = slides.length - 1;

      const noFade = slides.length <= 1;
      const atStart = activeIndex <= 0;
      const atEnd = activeIndex >= lastIndex;

      thumbs.classList.toggle(
        noFadeClass,
        noFade
      );

      thumbs.classList.toggle(
        scrolledClass,
        !noFade && !atStart
      );

      thumbs.classList.toggle(
        atEndClass,
        !noFade && atEnd
      );
    }

    function centreActiveThumbnail(animate = true) {
      const active = getActiveSlide(wrapper);

      if (!active) {
        return;
      }

      const containerWidth = container.clientWidth;

      const activeCentre =
        active.offsetLeft +
        (active.offsetWidth / 2);

      const targetX =
        (containerWidth / 2) -
        activeCentre;

      wrapper.style.setProperty(
        'transition',
        animate
          ? 'transform 180ms ease'
          : 'none',
        'important'
      );

      wrapper.style.setProperty(
        cssVariable,
        `${targetX}px`
      );

      updateFades();
    }

    function scheduleActiveUpdate(animate = true) {
      if (rafId) {
        cancelAnimationFrame(rafId);
      }

      rafId = requestAnimationFrame(function () {
        rafId = null;
        centreActiveThumbnail(animate);
      });
    }

    const activeObserver =
      new MutationObserver(function (mutations) {
        let activeChanged = false;

        mutations.forEach(function (mutation) {
          if (
            mutation.type === 'attributes' &&
            mutation.attributeName === 'class'
          ) {
            activeChanged = true;
          }
        });

        if (activeChanged) {
          scheduleActiveUpdate(true);
        }
      });

    function observeSlides() {
      getSlides().forEach(function (slide) {
        activeObserver.observe(slide, {
          attributes: true,
          attributeFilter: ['class']
        });
      });
    }

    observeSlides();

    const childObserver =
      new MutationObserver(function (mutations) {
        let rebuilt = false;

        mutations.forEach(function (mutation) {
          if (mutation.type === 'childList') {
            rebuilt = true;
          }
        });

        if (!rebuilt) {
          return;
        }

        observeSlides();

        requestAnimationFrame(function () {
          centreActiveThumbnail(false);
        });
      });

    childObserver.observe(wrapper, {
      childList: true,
      subtree: false
    });

    thumbs.addEventListener(
      'click',
      function () {
        setTimeout(function () {
          scheduleActiveUpdate(true);
        }, 0);
      }
    );

    window.addEventListener(
      'resize',
      function () {
        if (!isMobile()) {
          return;
        }

        scheduleActiveUpdate(false);
      }
    );

    requestAnimationFrame(function () {
      centreActiveThumbnail(false);
    });

    console.log(
      `[CPB Thumbnails] Layout ${layoutNumber} initialised`
    );

    return true;
  }

  function initLayout1(builder) {
    return initHorizontalCentredLayout(
      builder,
      1
    );
  }

  function initLayout2(builder) {
    const {
      thumbs,
      wrapper
    } = getThumbnailElements(builder);

    if (!thumbs || !wrapper) {
      return false;
    }

    if (
      wrapper.dataset.cpbLayout2Initialised ===
      'true'
    ) {
      return true;
    }

    wrapper.dataset.cpbLayout2Initialised =
      'true';

    const ACTIVE_REVEAL_GAP = 6;

    let fadeRafId = null;
    let revealRafId = null;

    function getSlides() {
      return Array.from(
        wrapper.querySelectorAll('.swiper-slide')
      );
    }

    function updateFade() {
      const maxScroll =
        thumbs.scrollHeight -
        thumbs.clientHeight;

      const hasOverflow = maxScroll > 2;

      const atTop =
        thumbs.scrollTop <= 2;

      const atBottom =
        thumbs.scrollTop >=
        maxScroll - 2;

      thumbs.classList.toggle(
        'cpb-layout2-thumbs-has-overflow',
        hasOverflow
      );

      thumbs.classList.toggle(
        'cpb-layout2-thumbs-scrolled',
        hasOverflow && !atTop
      );

      thumbs.classList.toggle(
        'cpb-layout2-thumbs-at-end',
        hasOverflow && atBottom
      );
    }

    function scheduleFadeUpdate() {
      if (fadeRafId) {
        cancelAnimationFrame(fadeRafId);
      }

      fadeRafId =
        requestAnimationFrame(function () {
          fadeRafId = null;
          updateFade();
        });
    }

    function revealThumbnail(
      slide,
      behavior = 'smooth'
    ) {
      if (!slide) {
        return;
      }

      const maxScroll =
        thumbs.scrollHeight -
        thumbs.clientHeight;

      if (maxScroll <= 2) {
        return;
      }

      const railRect =
        thumbs.getBoundingClientRect();

      const slideRect =
        slide.getBoundingClientRect();

      const visibleTop =
        railRect.top +
        ACTIVE_REVEAL_GAP;

      const visibleBottom =
        railRect.bottom -
        ACTIVE_REVEAL_GAP;

      if (
        slideRect.top >= visibleTop &&
        slideRect.bottom <= visibleBottom
      ) {
        return;
      }

      if (slideRect.top < visibleTop) {
        const difference =
          slideRect.top -
          visibleTop;

        const target =
          Math.max(
            0,
            thumbs.scrollTop + difference
          );

        thumbs.scrollTo({
          top: target,
          behavior
        });

        return;
      }

      if (
        slideRect.bottom >
        visibleBottom
      ) {
        const difference =
          slideRect.bottom -
          visibleBottom;

        const target =
          Math.min(
            maxScroll,
            thumbs.scrollTop + difference
          );

        thumbs.scrollTo({
          top: target,
          behavior
        });
      }
    }

    function scheduleThumbnailReveal(slide) {
      if (revealRafId) {
        cancelAnimationFrame(revealRafId);
      }

      revealRafId =
        requestAnimationFrame(function () {
          revealRafId = null;

          requestAnimationFrame(function () {
            revealThumbnail(
              slide,
              'smooth'
            );
          });
        });
    }

    thumbs.addEventListener(
      'scroll',
      scheduleFadeUpdate,
      {
        passive: true
      }
    );

    thumbs.addEventListener(
      'click',
      function (event) {
        const slide =
          event.target.closest(
            '.swiper-slide'
          );

        if (!slide) {
          return;
        }

        scheduleThumbnailReveal(slide);
      }
    );

    const childObserver =
      new MutationObserver(function (mutations) {
        let rebuilt = false;

        mutations.forEach(function (mutation) {
          if (
            mutation.type === 'childList'
          ) {
            rebuilt = true;
          }
        });

        if (!rebuilt) {
          return;
        }

        requestAnimationFrame(function () {
          scheduleFadeUpdate();
        });
      });

    childObserver.observe(wrapper, {
      childList: true,
      subtree: false
    });

    window.addEventListener(
      'resize',
      function () {
        if (!isMobile()) {
          return;
        }

        scheduleFadeUpdate();
      }
    );

    thumbs.scrollTop = 0;

    requestAnimationFrame(function () {
      updateFade();
    });

    console.log(
      '[CPB Thumbnails] Layout 2 initialised'
    );

    return true;
  }

  function initLayout3(builder) {
    return initHorizontalCentredLayout(
      builder,
      3
    );
  }

  function initialise() {
    const builder = getBuilder();

    if (!builder) {
      return false;
    }

    const thumbnailLayout =
      applyLayoutClass(builder);

    applyObjectFitClass(builder);

    if (!isMobile()) {
      return true;
    }

    if (thumbnailLayout === 1) {
      return initLayout1(builder);
    }

    if (thumbnailLayout === 2) {
      return initLayout2(builder);
    }

    if (thumbnailLayout === 3) {
      return initLayout3(builder);
    }

    return true;
  }

  function start() {
    if (initialise()) {
      return;
    }

    let attempts = 0;

    const interval =
      setInterval(function () {
        attempts += 1;

        if (
          initialise() ||
          attempts >= 60
        ) {
          clearInterval(interval);
        }
      }, 250);
  }

  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      start,
      {
        once: true
      }
    );
  } else {
    start();
  }

})();